import { fork, all } from 'redux-saga/effects';
import { listSagas } from '@nextiva/engagement-ui';

import apiSaga from './apiSaga';
import imageLibrary from './imageLibrarySagas';
import templateListSagas from './templateListSagas';
import surveyListSagas from './surveyListSagas';
import previewScreenShotSagas from '../domains/previewThumbnail/sagas';
import questionBankSagas from '../domains/questionBank/sagas';

export default function* rootSaga() {
  yield all([
    fork(apiSaga),
    fork(imageLibrary),
    fork(listSagas),
    fork(surveyListSagas),
    fork(templateListSagas),
    fork(previewScreenShotSagas),
    fork(questionBankSagas),
  ]);
}
